import { render, staticRenderFns } from "./SmsConfig.vue?vue&type=template&id=4de31da2&"
import script from "./SmsConfig.vue?vue&type=script&lang=ts&"
export * from "./SmsConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports